export default [
    {
        path: "view-campaigns",
        name: "ViewCampaigns",
        meta:{
            permissionPath: 'campaigns.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "viewCampaigns" */ "@/views/loyaltyPanel/campaigns/tabs/ViewCampaigns.vue"
            ),
        },
    {
        path: "view-campaign/:campaign_id/report",
        name: "CampaignReport",
        meta:{
            permissionPath: 'campaigns.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "viewCampaigns" */ "@/views/loyaltyPanel/campaigns/ViewCampaignReport.vue"
            ),
    },

    {
        path: "new-campaign",
        name: "New Campaign",
        meta:{
            permissionPath: 'campaigns.create',
        },
        component: () =>
            import(
                /* webpackChunkName: "newCampaign" */ "@/views/loyaltyPanel/campaigns/NewCampaign.vue"
            )
    },

    {
        path: "new-reward",
        name: "New Reward",
        meta:{
            permissionPath: 'rewards.create',
        },
        component: () =>
            import(
                /* webpackChunkName: "newCampaign" */ "@/views/loyaltyPanel/campaigns/NewReward.vue"
            )
    },

    {
        path: "view-rewards",
        name: "View Rewards",
        meta:{
            permissionPath: 'rewards.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "newCampaign" */ "@/views/loyaltyPanel/campaigns/tabs/ViewRewards.vue"
            )
    },

    {
        path: "email-themes",
        name: "Email Themes",
        component: () =>
            import(
                /* webpackChunkName: "newCampaign" */ "@/views/loyaltyPanel/campaigns/tabs/EmailThemes.vue"
            )
    },
];
